import '../../styles/test-system.css';

/* Only the statuses a candidate can ever see reach this component: the catalog
   serves open, confirmation and running, and a cycle page can additionally be
   reached for one that ended or was cancelled while it was open. */
const STATUS_LABELS = {
    open: { label: 'Open for enrolment', tone: 'ok' },
    confirmation: { label: 'Confirmation window', tone: 'warn' },
    running: { label: 'Running', tone: 'live' },
    ended: { label: 'Ended', tone: '' },
    cancelled: { label: 'Cancelled', tone: '' },
    archived: { label: 'Archived', tone: '' },
    draft: { label: 'Draft', tone: '' },
};

/* A cohort sits at `open` from the moment it is published until its confirmation
   window opens, so "open" outlives the enrolment it names: past the cutoff the
   document still says open while every CTA on the page is shut. The chip follows
   what a candidate can do, and `data-status` keeps saying what the document says.

   @param {string} status - The cycle's own status
   @param {boolean} [enrolmentOpen] - `isEnrolmentOpen`, when the caller knows it
   @param {boolean} [full] - `isCycleFull`, when the caller knows it */
const CycleStatusChip = ({ status, enrolmentOpen, full }) => {
    const open = status === 'open';
    const derived = open && enrolmentOpen === false
        ? { label: 'Enrolment closed', tone: '' }
        : open && full
            ? { label: 'Full', tone: '' }
            : null;
    const { label, tone } = derived
        || STATUS_LABELS[status]
        || { label: status || 'Unknown', tone: '' };

    return (
        <span className={`ts-chip${tone ? ` ts-chip--${tone}` : ''}`} data-status={status}>
            <span className="ts-chip-dot" />
            {label}
        </span>
    );
};

export default CycleStatusChip;
